var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from '@tanstack/react-query';
export var convertBasicTokenInfoToCovalentBalanceItem = function (basicTokenInfo) {
    var _a, _b;
    if (!basicTokenInfo.token) {
        return {
            contract_address: '',
            contract_decimals: 0,
            contract_name: '',
            contract_ticker_symbol: '',
            logo_url: '',
            network: 0,
        };
    }
    var token = basicTokenInfo.token;
    var tokenInfo = (_a = basicTokenInfo.tokenInfo) === null || _a === void 0 ? void 0 : _a[0];
    return {
        contract_address: token.address,
        contract_decimals: token.decimals,
        contract_name: token.name,
        contract_ticker_symbol: token.symbol,
        logo_url: (_b = token.info) === null || _b === void 0 ? void 0 : _b.imageThumbUrl,
        network: token.networkId,
        balance: '0',
        quote_rate: Number(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.priceUSD) || 0,
    };
};
export var getBasicTokenInfo = function (network_1, token_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([network_1, token_1], args_1, true), Promise, function (network, token, includePairInfo) {
        var tokenData, baseUrl, url, response, payload, data;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (includePairInfo === void 0) { includePairInfo = false; }
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    tokenData = {
                        token: null,
                        tokenInfo: null,
                        prices: null,
                    };
                    baseUrl = process.env.NEXTAUTH_URL || '';
                    url = "".concat(baseUrl, "/api/explore/basicToken?token=").concat(token, "&network=").concat(network, "&includePairInfo=").concat(includePairInfo);
                    return [4 /*yield*/, fetch(url, {
                            headers: {
                                'Cache-Control': 'no-store, no-cache, max-age=0, must-revalidate',
                                Pragma: 'no-cache',
                            },
                        })];
                case 1:
                    response = _l.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    payload = _l.sent();
                    data = payload === null || payload === void 0 ? void 0 : payload.data;
                    tokenData = {
                        pairs: (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.listPairsWithMetadataForToken) !== null && _b !== void 0 ? _b : null,
                        token: (_d = (_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.token) !== null && _d !== void 0 ? _d : null,
                        tokenInfo: (_f = (_e = data === null || data === void 0 ? void 0 : data.data) === null || _e === void 0 ? void 0 : _e.filterTokens) !== null && _f !== void 0 ? _f : null,
                        prices: (_h = (_g = data === null || data === void 0 ? void 0 : data.data) === null || _g === void 0 ? void 0 : _g.getTokenPrices) !== null && _h !== void 0 ? _h : null,
                        tokenStats: (_k = (_j = data === null || data === void 0 ? void 0 : data.data) === null || _j === void 0 ? void 0 : _j.aggregatedPairInfo) !== null && _k !== void 0 ? _k : null,
                    };
                    return [2 /*return*/, tokenData];
            }
        });
    });
};
export default function useBasicTokenInfo(_a) {
    var _this = this;
    var network = _a.network, token = _a.token;
    var query = useQuery({
        queryKey: ['basicTokenInfo', network, token],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getBasicTokenInfo(network, token)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!network && !!token,
    });
    return query;
}
export function useBasicTokenInfoList(tokenPairs) {
    var _this = this;
    var query = useQuery({
        queryKey: ['savedTokensQuery', tokenPairs],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var results;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(tokenPairs.map(function (token) { return __awaiter(_this, void 0, void 0, function () {
                            var data;
                            var _a, _b, _c, _d;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0:
                                        if (!token.network || !token.token)
                                            return [2 /*return*/, null];
                                        return [4 /*yield*/, getBasicTokenInfo(token.network, token.token)];
                                    case 1:
                                        data = _e.sent();
                                        data = __assign(__assign(__assign({}, data), (_b = (_a = data === null || data === void 0 ? void 0 : data.tokenInfo) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b[0]), { token: __assign(__assign({}, data === null || data === void 0 ? void 0 : data.token), { imageLargeUrl: (_d = (_c = data === null || data === void 0 ? void 0 : data.token) === null || _c === void 0 ? void 0 : _c.info) === null || _d === void 0 ? void 0 : _d.imageThumbUrl }) });
                                        return [2 /*return*/, data];
                                }
                            });
                        }); }))];
                    case 1:
                        results = _a.sent();
                        return [4 /*yield*/, results];
                    case 2: 
                    // Filter out any null or undefined results
                    return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        enabled: tokenPairs.length > 0,
    });
    return query;
}
